var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#5E6073"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2353 12H15.7647C13.6855 12 12 13.6855 12 15.7647V24.2353C12 26.3145 13.6855 28 15.7647 28H24.2353C26.3145 28 28 26.3145 28 24.2353V15.7647C28 13.6855 26.3145 12 24.2353 12ZM13.4118 15.7647C13.4118 14.4652 14.4652 13.4118 15.7647 13.4118H24.2353C25.5348 13.4118 26.5882 14.4652 26.5882 15.7647V24.2353C26.5882 25.5348 25.5348 26.5882 24.2353 26.5882H15.7647C14.4652 26.5882 13.4118 25.5348 13.4118 24.2353V15.7647ZM16 20C16 22.2091 17.7909 24 20 24C22.2091 24 24 22.2091 24 20C24 17.7909 22.2091 16 20 16C17.7909 16 16 17.7909 16 20ZM22.5882 20C22.5882 21.4294 21.4294 22.5882 20 22.5882C18.5706 22.5882 17.4118 21.4294 17.4118 20C17.4118 18.5706 18.5706 17.4118 20 17.4118C21.4294 17.4118 22.5882 18.5706 22.5882 20ZM25.1773 15.7654C25.1773 16.2852 24.7559 16.7066 24.2361 16.7066C23.7163 16.7066 23.2949 16.2852 23.2949 15.7654C23.2949 15.2456 23.7163 14.8242 24.2361 14.8242C24.7559 14.8242 25.1773 15.2456 25.1773 15.7654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f9124b96f688d939fb4ba33b28ce3d78.svg";
export { ForwardRef as ReactComponent };